export const styles = {
  text: {
    adminPageHeader: {
      fontWeight: 700,
      letterSpacing: 2,
      fontSize: { lg: "2.2rem", md: "2rem", sm: "1.8rem", xs: "1.6rem" },
    },
  },
};
